import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDashboardPath, UNIFIED_LOGIN_PATH } from "../../utils/authRedirect";
import clinicAPI from "../../services/clinicApi";
import { isClubWebsiteAllowed } from "../../utils/clubWebsiteAccess";
import ClubWebsite from "./ClubWebsite";

/**
 * Корень портала клуба (/):
 * — авторизован → кабинет;
 * — сайт включён (бета: только baysport) → публичная визитка;
 * — иначе → вход.
 */
export default function PortalEntryRedirect() {
  const { isAuth, role } = useSelector((state) => state.auth);
  const [clinic, setClinic] = useState(undefined);

  useEffect(() => {
    if (isAuth && role) return undefined;
    let cancelled = false;
    clinicAPI
      .getPublicClinicPortal()
      .then((data) => {
        if (!cancelled) setClinic(data?.clinic || data?.tenant || null);
      })
      .catch(() => {
        if (!cancelled) setClinic(null);
      });
    return () => {
      cancelled = true;
    };
  }, [isAuth, role]);

  if (isAuth && role) {
    return <Navigate to={getDashboardPath(role)} replace />;
  }

  if (clinic === undefined) {
    return null;
  }

  if (clinic?.website_enabled && isClubWebsiteAllowed(clinic) && clinic.website_purchased_at) {
    return <ClubWebsite clinic={clinic} />;
  }

  return <Navigate to={UNIFIED_LOGIN_PATH} replace />;
}
